module.exports = __webpack_public_path__ + "c38b81c4cd63bcfe1e311107b6b01c05.svg";


//////////////////
// WEBPACK FOOTER
// ./directives/navbar/profile.svg
// module id = 245
// module chunks = 0